import { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../components/baseurl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Home = () => {
  const [globalPosts, setGlobalPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setLoading(true);
    let url = `${API_BASE_URL}/api/my-content/public/?`;
    if (selectedCategory) url += `category=${selectedCategory}&`;
    if (searchTerm) url += `search=${searchTerm}&`;

    axios
      .get(url)
      .then((res) => setGlobalPosts(res.data))
      .catch((err) => {
        console.error(err);
        toast.error("Failed to load global posts.");
      })
      .finally(() => setLoading(false));
  }, [selectedCategory, searchTerm]);

  return (
    <div className="container mt-4">
      <ToastContainer position="bottom-right" autoClose={3000} />

      <h2>🌍 Global Feed</h2>

      <div className="d-flex gap-2 mb-4">
        <select
          className="form-select w-auto"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">All Categories</option>
          <option value="tech">Technology</option>
          <option value="life">Lifestyle</option>
          <option value="news">News</option>
          <option value="sports">Sports</option>
        </select>

        <input
          type="text"
          className="form-control"
          placeholder="Search by keyword or category..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {selectedCategory && (
        <h5 className="mb-3">Filtered by Category: <span className="badge bg-secondary">{selectedCategory}</span></h5>
      )}

      {loading ? (
        <div className="d-flex justify-content-center mt-5">
          <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }}></div>
        </div>
      ) : globalPosts.length === 0 ? (
        <p>No public posts found.</p>
      ) : (
        <div className="accordion" id="globalAccordion">
          {globalPosts.map((item, index) => (
            <div className="accordion-item" key={item.id}>
              <h2 className="accordion-header" id={`globalHeading${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#globalCollapse${index}`}
                  aria-expanded="false"
                  aria-controls={`globalCollapse${index}`}
                >
                  {item.title}
                  <span className="ms-2 badge bg-info text-dark">@{item.username}</span>
                  {item.category && (
                    <span className="ms-2 badge bg-info text-dark">#{item.category}</span>
                  )}
                </button>
              </h2>
              <div
                id={`globalCollapse${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`globalHeading${index}`}
                data-bs-parent="#globalAccordion"
              >
                <div className="accordion-body">
                  <p>{item.body}</p>
                  <p className="text-muted" style={{ fontSize: "0.85rem" }}>
                    Posted on {new Date(item.created_at).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Home;

